<script>
import LogoComponent from './Logo.vue';
import MenuComponent from '../Menu/component.vue';

export default {
  components: {
    LogoComponent,
    MenuComponent,
  },
  props: {
    module: {
      type: Object,
    },
    value: Boolean,
  },
  data: () => ({}),
  computed: {
    mini() {
      return this.module.menu.min;
    },
    background() {
      return this.module.setting.get('MenuBackground') || '';
    },
    isDark() {
      const background = this.background.replace('#', '');
      if (background.length === 6) {
        return background[0] < 8 && background[2] < 8 && background[4] < 8;
      }
      if (background.length === 3) {
        return background[0] < 8 && background[1] < 8 && background[2] < 8;
      }
      return true;
    },
    val: {
      get() {
        return this.value;
      },
      set(value) {
        return this.$emit('input', value);
      },
    },
  },
  methods: {},
  mounted() {
  },
};
</script>
<template>
  <v-navigation-drawer
    v-show="module.show"
    id="mag-template-nav"
    v-model="val"
    :color="background"
    :mini-variant="mini"
    :dark="isDark"
    app
  >
    <LogoComponent
      :mini="mini"
    />
    <MenuComponent
      :module="module.menu"
    />
  </v-navigation-drawer>
</template>
<style lang="scss">
  #mag-template-nav {
    ::-webkit-scrollbar {
      width: 6px;
      background: #ffffff66;
    }

    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px grey;
      border-radius: 10px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: #00000066;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #000000;
    }

    .v-list-item {
      border-bottom: 1px solid rgba(0, 0, 0, 0.15);

    }

    .v-list.theme--dark {
      .v-list-item {
        border-bottom: 1px solid rgba(255, 255, 255, 0.15);
      }
    }
  }
</style>
